module.exports = __webpack_public_path__ + "img/nav01_h.7c934600.png";